import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Dashboards, EcommerceDashboard } from "../../../Constant";
import Earning from "./Earning";
import TransactionHistory from "./TransactionHistory";
import AuditLog from "./AuditLog";
import UserInformation from "./UserInformation";
import SalesSummary from "./SalesSummary";
import Traffic from "./Traffic";
import NewsAndUpdate from "./NewsAndUpdate";
import OverAllRating from "./OverAllRating";
import ManageOrder from "./ManageOrder/inex";
import ScheduleLesson from "./ScheduleLesson";


const EcommerceDashboardContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={EcommerceDashboard} parent={Dashboards} title={EcommerceDashboard} />
      <Container fluid className="ecommerce-dashboard">
        <Row className="widget-grid">
          <Earning />
          <TransactionHistory />
          <AuditLog />
          <UserInformation />
          <SalesSummary />
          <Traffic />
          <NewsAndUpdate />
          <OverAllRating />
          <ManageOrder />
          <ScheduleLesson />
        </Row>
      </Container>
    </>
  );
};

export default EcommerceDashboardContainer;
